import { WordStart } from './';
import { CellItem } from 'vue/types/vue';
import { Note } from './note';

export class PuzzleBuildData
{
    public cellstates: string = "";
    public arrows: CellItem[] = [];
    public wordstarts: WordStart[] = [];
    public dashes: CellItem[] = [];
    public answer: string[] = [];
    public width: number = 0;
    public notes: Note[] = new Array<Note>();

    public setAnswer(answer: string[]): void
    {
        this.answer = answer;
    }
    public setStates(states: string): void
    {

        this.cellstates = states;
    }
    public setWordStarts(starts: WordStart[]): void
    {
        this.wordstarts = starts;
    }
    public setDashes(dashes: CellItem[]): void
    {
        this.dashes = dashes;
    }
    public setArrows(arrows: CellItem[])
    {
        this.arrows = arrows;
    }
    public setWidth(width: number): void
    {
        this.width = width;
    }
    public setNotes(notes: Note[]): void {
        this.notes = notes;
    }

}

export class PuzzleBuild
{

    public puzzleName: string;
    public data: PuzzleBuildData = new PuzzleBuildData();

    constructor(name: string = "", data: PuzzleBuildData)
    {
        this.puzzleName = name;
        this.data = data;
    }

}